import GENERAL from '../../../api/general';

const state = {
  activeTab: '',
  refresh: {
    settlementSummary: false,
  },
  isChangeParentDetected: false,
  // Pełna analiza wspólnego paska podsumowania faktur rozwinięta w bieżącej sesji (PUB-1627).
  // Moduł GENERAL nie jest utrwalany — po przeładowaniu wraca domyślny wariant kompaktowy.
  invoiceSummaryExpanded: false,
};

const getters = {};

const actions = {
  convertNumberToMoneyFormat({ commit }, number) {
    commit('LOADER/setLoading', true, { root: true });
    return new Promise((resolve, reject) => {
      GENERAL.convertNumberToMoneyFormat(number).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {
        commit('LOADER/setLoading', false, { root: true });
      });
    });
  },
  refresh({ commit }, payload) {
    commit('refresh', payload);
  },
};

const mutations = {
  setActiveTab(state, tab) {
    state.activeTab = tab;
  },

  setIsChangeParentDetected(state, value) {
    state.isChangeParentDetected = !!value;
  },

  setInvoiceSummaryExpanded(state, value) {
    state.invoiceSummaryExpanded = !!value;
  },

  refresh(state, payload) {
    state.refresh = {
      ...state.refresh,
      ...payload,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
